import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule,  MatDialogRef } from '@angular/material/dialog';

export interface NewClaimExitInvalidDialogData {
  fields: string[];
}

@Component({
  selector: 'app-new-claim-exit-invalid-dialog',
  templateUrl: './new-claim-exit-invalid-dialog.component.html',
  styleUrls: ['./new-claim-exit-invalid-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule
  ]
})
export class NewClaimExitInvalidDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: NewClaimExitInvalidDialogData,
    public dialogRef: MatDialogRef<NewClaimExitInvalidDialogComponent>
  ) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}